// extracted by mini-css-extract-plugin
module.exports = {"key":"style_key__1I1vGRTFW4Imqjhnz2o73i","row":"style_row__3b2vuitL7Mag5BDo_RppoK"};